// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles pour SuiviDeCommandeBC - Interface Prestataire */
.suivi-commande {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.suivi-commande-title {
  position: relative;
  background-color: black;
  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg"); */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 2rem 4rem;
  color: black;
  margin-bottom: 2rem;
}

.suivi-commande-title h1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
  font-size: 3.2rem;
  font-weight: 700;
  margin: 0;
}

.suivi-de-commande-content {
  padding: 1rem 2rem;
  background-color: white;
  border-radius: 12px;
  margin: 0 2rem 2rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* .subtitle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
  margin-bottom: 2rem;
  color: #6B7280;
} */

.subsequent-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1.8rem 2.5rem;
  background: linear-gradient(135deg, #da7027, #f4a460);
  border-radius: 50px;
  font-weight: 700;
  font-size: 2.4rem;
  margin-bottom: 2rem;
  color: white;
  box-shadow: 0 4px 12px rgba(218, 112, 39, 0.3);
}

/* États spécifiques aux prestataires */
/* .commande-status .status-header {
  margin-bottom: 1rem;
}

.status-header span {
  font-size: 1.8rem;
  font-weight: 700;
  padding: 0.8rem 1.6rem;
  border-radius: 8px;
  display: inline-block;
}  */

.commande-status .status-header {
  margin-bottom: 0;
}

.status-header span {
  font-size: 1.6rem;
  font-weight: 700;
}

.status-accepté,
.status-valide {
  color: #00a708;
}

.status-brouillon,
.status-brouillon-prestataire,
.status-brouillon-acheteur,
.status-en-attente-de-l-offre {
  color: #6b7280;
}

.status-en-consultation {
  color: white;
  background-color: #3b82f6;
}

.status-candidature-soumise,
.status-en-attente-de-votre-acceptation,
.status-a-chiffrer {
  color: #da7027;
}

.status-refusé,
.status-refuse {
  color: #dc2626;
}

.status-en-attente {
  color: white;
  background-color: #6b7280;
}

.dates {
  font-size: 1.6rem;
  font-weight: 600;
  margin-top: 1rem;
}

.dates span {
  color: #6b7280;
  font-weight: 400;
  font-size: 1.4rem;
}

.dates p {
  margin-bottom: 0.5rem;
  color: #2c3948;
}

.tab-content {
  padding: 2rem 0;
  min-height: 500px;
}

@media print {
  .tab-content {
    padding: 0 !important;
  }
}

/* États de chargement et d'erreur */
.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 1.8rem;
  color: #6b7280;
}

.error-message p {
  color: #dc2626;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 1.8rem;
  color: #6b7280;
  text-align: center;
  background-color: #f9fafb;
  border-radius: 8px;
  margin: 2rem;
}

/* Styles spécifiques aux prestataires */
.prestataire-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  /* margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb; */
}

.prestataire-info {
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.prestataire-info h3 {
  color: #1e40af;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}

.prestataire-info p {
  color: #1e3a8a;
  font-size: 1.4rem;
  line-height: 1.5;
}

/* Validation et erreurs */
.form-errors {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
}

.form-errors ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.form-errors li {
  color: #dc2626;
  font-size: 1.4rem;
  margin-bottom: 0.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .suivi-de-commande-content {
    padding: 0 2rem 2rem 2rem;
    margin: 0 1rem 1rem 1rem;
  }

  .suivi-commande-title {
    padding: 1.5rem 2rem;
  }

  .suivi-commande-title h1 {
    font-size: 2.4rem;
  }

  .subsequent-badge {
    font-size: 2rem;
    padding: 1.5rem 2rem;
  }

  .prestataire-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .suivi-de-commande-content {
    padding: 0 1rem 1rem 1rem;
    margin: 0 0.5rem 0.5rem 0.5rem;
  }

  .suivi-commande-title {
    padding: 1rem;
  }

  .dates {
    font-size: 1.4rem;
  }

  .subtitle {
    font-size: 1.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommandeBCI/SuiviDeCommandeBCI.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;mFACiF;EACjF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;;;;;;;;GAQG;;AAEH;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qDAAqD;EACrD,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA,uCAAuC;AACvC;;;;;;;;;;IAUI;;AAEJ;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB;;kCAEgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Styles pour SuiviDeCommandeBC - Interface Prestataire */\n.suivi-commande {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.suivi-commande-title {\n  position: relative;\n  background-color: black;\n  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\n    url(\"../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg\"); */\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding: 2rem 4rem;\n  color: black;\n  margin-bottom: 2rem;\n}\n\n.suivi-commande-title h1 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: block;\n  font-size: 3.2rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.suivi-de-commande-content {\n  padding: 1rem 2rem;\n  background-color: white;\n  border-radius: 12px;\n  margin: 0 2rem 2rem 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* .subtitle {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n  margin-bottom: 2rem;\n  color: #6B7280;\n} */\n\n.subsequent-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.8rem 2.5rem;\n  background: linear-gradient(135deg, #da7027, #f4a460);\n  border-radius: 50px;\n  font-weight: 700;\n  font-size: 2.4rem;\n  margin-bottom: 2rem;\n  color: white;\n  box-shadow: 0 4px 12px rgba(218, 112, 39, 0.3);\n}\n\n/* États spécifiques aux prestataires */\n/* .commande-status .status-header {\n  margin-bottom: 1rem;\n}\n\n.status-header span {\n  font-size: 1.8rem;\n  font-weight: 700;\n  padding: 0.8rem 1.6rem;\n  border-radius: 8px;\n  display: inline-block;\n}  */\n\n.commande-status .status-header {\n  margin-bottom: 0;\n}\n\n.status-header span {\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n\n.status-accepté,\n.status-valide {\n  color: #00a708;\n}\n\n.status-brouillon,\n.status-brouillon-prestataire,\n.status-brouillon-acheteur,\n.status-en-attente-de-l-offre {\n  color: #6b7280;\n}\n\n.status-en-consultation {\n  color: white;\n  background-color: #3b82f6;\n}\n\n.status-candidature-soumise,\n.status-en-attente-de-votre-acceptation,\n.status-a-chiffrer {\n  color: #da7027;\n}\n\n.status-refusé,\n.status-refuse {\n  color: #dc2626;\n}\n\n.status-en-attente {\n  color: white;\n  background-color: #6b7280;\n}\n\n.dates {\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-top: 1rem;\n}\n\n.dates span {\n  color: #6b7280;\n  font-weight: 400;\n  font-size: 1.4rem;\n}\n\n.dates p {\n  margin-bottom: 0.5rem;\n  color: #2c3948;\n}\n\n.tab-content {\n  padding: 2rem 0;\n  min-height: 500px;\n}\n\n@media print {\n  .tab-content {\n    padding: 0 !important;\n  }\n}\n\n/* États de chargement et d'erreur */\n.loading-indicator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 1.8rem;\n  color: #6b7280;\n}\n\n.error-message p {\n  color: #dc2626;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n}\n\n.empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 1.8rem;\n  color: #6b7280;\n  text-align: center;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin: 2rem;\n}\n\n/* Styles spécifiques aux prestataires */\n.prestataire-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  /* margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid #e5e7eb; */\n}\n\n.prestataire-info {\n  background-color: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.prestataire-info h3 {\n  color: #1e40af;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n}\n\n.prestataire-info p {\n  color: #1e3a8a;\n  font-size: 1.4rem;\n  line-height: 1.5;\n}\n\n/* Validation et erreurs */\n.form-errors {\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 2rem;\n}\n\n.form-errors ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.form-errors li {\n  color: #dc2626;\n  font-size: 1.4rem;\n  margin-bottom: 0.5rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .suivi-de-commande-content {\n    padding: 0 2rem 2rem 2rem;\n    margin: 0 1rem 1rem 1rem;\n  }\n\n  .suivi-commande-title {\n    padding: 1.5rem 2rem;\n  }\n\n  .suivi-commande-title h1 {\n    font-size: 2.4rem;\n  }\n\n  .subsequent-badge {\n    font-size: 2rem;\n    padding: 1.5rem 2rem;\n  }\n\n  .prestataire-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .suivi-de-commande-content {\n    padding: 0 1rem 1rem 1rem;\n    margin: 0 0.5rem 0.5rem 0.5rem;\n  }\n\n  .suivi-commande-title {\n    padding: 1rem;\n  }\n\n  .dates {\n    font-size: 1.4rem;\n  }\n\n  .subtitle {\n    font-size: 1.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
